export default "__VITE_ASSET__9BxV86oR__"